import { useEffect, useState } from "react";

import { DoctorsApi } from "../../../Api/DoctorsApi";

import { mapFiltersToRequest } from "../Filters/Utils";
import { Filters } from "../Filters/types";
import { GetInsuranceDoctorsResponseDto } from "@apiModels/Insurance/GetInsuranceDoctorsResponseDto.csharp";

interface useFilteredDoctorsReturn extends GetInsuranceDoctorsResponseDto {
  isLoading: boolean;
}

const api = new DoctorsApi();

export function useFilteredDoctors(
  filters: Filters,
  getFavorites: boolean
): useFilteredDoctorsReturn {
  const [isLoading, setIsLoading] = useState(true);
  const [response, setResponse] = useState<GetInsuranceDoctorsResponseDto>({
    doctors: [],
    keywords: [],
  });

  useEffect(() => {
    if (filters.semaphore) {
      const requestBody = mapFiltersToRequest(filters, getFavorites);

      (async function () {
        setIsLoading(true);
        const apiResponse = await api.getFilteredInsurance(requestBody);
        setResponse(apiResponse);
        setIsLoading(false);
      })();
    }
  }, [filters]);

  return {
    isLoading,
    ...response,
  };
}
